module.exports = __webpack_public_path__ + "img/img1.aed4fc5f.jpg";